import $ from "jquery";
// inicializácia po načítaní DOMu
$(function () {
    var currentPage = $("#currentPage").val();
    if (currentPage != "home")
        return;
    initFactsSlider();
    initTechSlider();
    // =========================
    // MATERIALS (existing)
    // =========================
    var $materials = $("#materials");
    var $items = $materials.find(".home-material-item");
    var $list = $materials.find(".home-material-list");
    var $wrap = $materials.find(".home-materials-wrap");
    var $preview = $materials.find("#materialPreview");
    var $img = $materials.find("#materialPreviewImage");
    var $btn = $materials.find("#materialPreviewButton");
    function isDesktop() {
        return window.matchMedia("(min-width: 992px)").matches;
    }
    function clamp(value, min, max) {
        return Math.max(min, Math.min(max, value));
    }
    function positionPreviewToItem($item) {
        if (!isDesktop())
            return;
        var wrapTop = $wrap.offset().top;
        var wrapHeight = $wrap.outerHeight() || 0;
        var itemTop = $item.offset().top;
        var itemHeight = $item.outerHeight() || 0;
        var previewHeight = $preview.outerHeight() || 0;
        var top = (itemTop - wrapTop) + (itemHeight / 2) - (previewHeight / 2);
        top = clamp(top, 0, Math.max(0, wrapHeight - previewHeight));
        $preview.css("top", "".concat(top, "px"));
    }
    function applyPreviewFromItem($it) {
        var img = $it.data("img");
        var url = $it.data("url");
        var id = $it.data("id");
        var desc = $it.data("description");
        if (img)
            $img.attr("src", img);
        $btn.attr("href", "#");
        //if (url) $btn.attr("href", url);
        if (id)
            $btn.data('id', id);
        if (url)
            $btn.data('url', url);
        console.log("Material ID for preview:", id);
        $items.removeClass("active");
        $it.addClass("active");
        $list.addClass("is-hovering");
        positionPreviewToItem($it);
        var $desc = $("#materialPreviewDescription");
        if ($desc.length)
            $desc.text(desc || "");
    }
    /* DESKTOP: hover -> preview */
    $items.on("mouseenter", function () {
        if (!isDesktop())
            return;
        applyPreviewFromItem($(this));
    });
    $items.on("mouseleave", function () {
        if (!isDesktop())
            return;
        $list.removeClass("is-hovering");
    });
    /* Keyboard accessibility: Enter/Space otvorí detail (na mobile aj desktope je to OK) */
    $items.on("keydown", function (e) {
        if (e.key !== "Enter" && e.key !== " ")
            return;
        var url = String($(this).data("url") || "");
        if (!url)
            return;
        e.preventDefault();
        window.location.href = url;
    });
    /* INIT: pri načítaní nastav prvý item ako preview (iba desktop) */
    var $first = $items.first();
    if ($first.length && isDesktop()) {
        applyPreviewFromItem($first);
        $list.removeClass("is-hovering"); // nech nie je ztlmenie hneď po load
    }
    /* resize: dorovnaj pozíciu preview podľa active (desktop) */
    $(window).on("resize", function () {
        if (!isDesktop())
            return;
        var $active = $items.filter(".active").first();
        if ($active.length)
            positionPreviewToItem($active);
    });
});
function initTechSlider() {
    var _a;
    var $slider = $(".tech-slider");
    if ($slider.length === 0)
        return;
    var $wrapper = $slider.find(".tech-scroll-wrapper");
    if ($wrapper.length === 0)
        return;
    var $cards = $wrapper.find(".home-tech-card");
    if ($cards.length === 0)
        return;
    var cardWidth = (_a = $cards.first().outerWidth(true)) !== null && _a !== void 0 ? _a : 0;
    var scrollStep = cardWidth * 1.02;
    var $leftArrow = $slider.find(".tech-arrow-left");
    var $rightArrow = $slider.find(".tech-arrow-right");
    function scrollByStep(direction) {
        var el = $wrapper.get(0);
        if (!el)
            return;
        var current = el.scrollLeft;
        var maxScroll = el.scrollWidth - el.clientWidth;
        var target = current + direction * scrollStep;
        if (target < 0)
            target = 0;
        if (target > maxScroll)
            target = maxScroll;
        el.scrollTo({ left: target, behavior: "smooth" });
    }
    $leftArrow.on("click", function (e) { e.preventDefault(); e.stopPropagation(); scrollByStep(-1); });
    $rightArrow.on("click", function (e) { e.preventDefault(); e.stopPropagation(); scrollByStep(1); });
}
function initFactsSlider() {
    var _a;
    var $slider = $(".facts-slider");
    if ($slider.length === 0)
        return;
    var $wrapper = $slider.find(".facts-scroll-wrapper");
    if ($wrapper.length === 0)
        return;
    var $inner = $wrapper.find(".facts-inner").first();
    var $blocks = $inner.find(".fact-block");
    if ($blocks.length === 0)
        return;
    var blockWidth = (_a = $blocks.first().outerWidth(true)) !== null && _a !== void 0 ? _a : 0;
    var scrollStep = blockWidth * 1.02;
    var $leftZone = $slider.find(".facts-click-zone-left");
    var $rightZone = $slider.find(".facts-click-zone-right");
    var $leftArrow = $slider.find(".facts-arrow-left");
    var $rightArrow = $slider.find(".facts-arrow-right");
    function scrollByStep(direction) {
        var el = $wrapper.get(0);
        if (!el)
            return;
        var current = el.scrollLeft;
        var maxScroll = el.scrollWidth - el.clientWidth;
        var target = current + direction * scrollStep;
        if (target < 0)
            target = 0;
        if (target > maxScroll)
            target = maxScroll;
        el.scrollTo({
            left: target,
            behavior: "smooth"
        });
    }
    if ($leftZone.length) {
        $leftZone.on("click", function (e) {
            e.preventDefault();
            scrollByStep(-1);
        });
    }
    if ($rightZone.length) {
        $rightZone.on("click", function (e) {
            e.preventDefault();
            scrollByStep(1);
        });
    }
    if ($leftArrow.length) {
        $leftArrow.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            scrollByStep(-1);
        });
    }
    if ($rightArrow.length) {
        $rightArrow.on("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            scrollByStep(1);
        });
    }
}
export { initFactsSlider };
//# sourceMappingURL=home.js.map